//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ForceFailNotifications: FeatureFlag = {"Id":"ForceFailNotifications","Label":"(QA) FORCE ALL NOTIFICATION TO FAIL","Impact":"For testing failure. Notification always are reported as failed to send.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
